export const getTheme = () => {
  const selectedTheme = localStorage.getItem('systemTheme');
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

  const themeOut = selectedTheme || systemTheme

  if (themeOut === 'dark') {
    localStorage.setItem('darkTheme', 'false');
    // localStorage.setItem('darkTheme', 'true');
  } else {
    localStorage.setItem('darkTheme', 'false');
  };

  return themeOut;
}
